var _Path, _Path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgHrMonitor(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#hr-monitor_svg__clip0_359:104)",
    stroke: props.color,
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.016 14.469h5.946l1.487-2.107 1.985 3.162 2.475-5.273 1.985 7.38 1.487-3.162h7.433"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M21.584 12.362a12.913 12.913 0 001.237-5.192c0-8.109-9.236-8.736-10.406-.627C11.24-1.566 2.004-.939 2.004 7.793c.016 1.578.324 3.138.906 4.59M5.207 16.575a33.755 33.755 0 007.193 7.267 42.718 42.718 0 006.714-7.267"
  }))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "hr-monitor_svg__clip0_359:104"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.color,
    transform: "translate(.296)",
    d: "M0 0h24.237v24.607H0z"
  }))));
}

export default SvgHrMonitor;